import { $ } from '@/libs/jquery/index'

export class PasswordTypeSwitcher {
  public base: JQuery | null = null

  private readonly selectors: ISelectors = {
    base: '[data-selector="PasswordTypeSwitcher"]',
  }

  constructor() {
    this.init()
  }

  public init(): void {
    $('body')
      .on('click', this.selectors.base, (e) => {
        const field = $(e.currentTarget).siblings('input')
        const type = field.prop('type') === 'password'
          ? 'text'
          : 'password'

        field.prop('type', type)
      })
  }
}
